import * as angular from "angular";
import {IController, IWindowService} from "angular";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import * as _ from "lodash";
import {CancellationReason} from "../../../cancellation-reasons/models/cancellationReason.model";
import {FulfillmentStepStatusType} from "../../types/fulfillment-step-status.type";
import {AttemptStatusType} from "../../types/attemptStatus.type";
import {FulfillmentStepDisplayStatusType} from "../../types/fulfillment-step-display-status.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OmsDialogService} from "../../../oms/services/oms-dialog-service.service";
import {OmsOrdersAlertsService} from "../../../oms/services/oms-orders-alerts.service";
import {OmsRequestsService} from "../../../oms/services/oms-requests.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {BillingAccountDialogService} from "../../../billing-accounts/services/billing-account-dialog-service.service";
import {BillingOrderService} from "../../../billing-accounts/services/billing-order.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";
import {FulfillmentService} from "../../services/fulfillment-service.service";
import {FulfillmentStepService} from "../../services/fulfillment-step-service.service";
import {ThreePLServiceActionsService} from "../../../threePL/angular/services/threepl-service-actions.service";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {
  CancellationReasonsDialogsService
} from "../../../cancellation-reasons/services/cancellation-reasons-dialogs-service.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";
import {
  ActionReasonsDialogsServiceService
} from "../../../action-reasons/services/action-reasons-dialogs-service.service";
import {FulfillmentStatusType} from "../../types/fulfillment-status.type";
import {getFulfillmentLineItems} from "../../utils/fulfillment-line-items.util";

export class FulfillmentViewComponent implements IController {

  fulfillment: any;
  order: any;
  fulfillmentLineStatus: any;
  doDispatch: boolean;
  isFullView: boolean;
  isPanelOpen: boolean;
  showOrderData: boolean;
  isShowCheckboxes: boolean;
  isShowLineCheckboxes: boolean;
  selectedSteps: any[];
  selectedStepsIds: string[];
  excludeMode: boolean;
  onLineSelectionChange: Function;
  isMobile: boolean;
  onFulfillmentUpdate: Function;
  onToggleFullView: Function;
  onToggleBack: Function;
  onToggleSelect: Function;

  private selectedStep: any;
  private selectedStepNumber: number;
  private relationsMap: any = {};
  private weightUnit: any;
  private distanceUnit: any;
  private volumeUnit: any;
  private settings: any;
  private siteLabels: any;
  private billingOrder: any;
  private isBillingOrderPanelInEditMode: boolean;
  private selectedTab: number;
  public showUrlTextCopy: boolean = false;
  public viewedStepsIds: string[] = [];
  public allowPrintingBillOfLading: boolean;
  public selectedKeys: any = undefined;
  public fulfillmentLinesPackages: any = {};
  public fulfillmentStepsPriceInfo: any;
  public fulfillmentLineStepsPriceInfoMap: any = {};
  public canCopyExternalId: boolean;
  public siteId: string;
  public attemptStatusType: typeof AttemptStatusType = AttemptStatusType;
  public fulfillmentStepStatusType: typeof FulfillmentStepStatusType = FulfillmentStepStatusType;
  public fulfillmentStepDisplayStatus: typeof FulfillmentStepDisplayStatusType = FulfillmentStepDisplayStatusType;
  public relations: any[];
  public fulfillmentRelationType: string;
  public fulfillmentRelatedOrderId: string;
  private fulfillmentServiceAreaIds: string[];
  public fulfillmentStatusType: typeof FulfillmentStatusType = FulfillmentStatusType;
  public isSuperOwner: boolean;
  public fulfillmentLinesMetadataMap: any;
  public selectedLineIds: any = {};
  public isAllLinesSelected: boolean;
  public isSomeLinesSelected: boolean;


  /* @ngInject */
  constructor(private $delivery, private fulfillmentService: FulfillmentService, private fulfillmentDialogService: FulfillmentDialogService, private confirmDialogService: ConfirmDialogService,
              private $log, private fulfillmentStepService: FulfillmentStepService, private $omsOrder, private splitService, private bringozLoaderService: BringozLoaderService,
              private $billingAccounts, private billingAccountDialogService: BillingAccountDialogService, private billingOrderService: BillingOrderService, private omsRequestsService: OmsRequestsService,
              private omsOrdersAlertsService: OmsOrdersAlertsService, private omsService: OmsService, private fileDownloader, private filePrinter, private DeliveriesApiAction, private commonsDialogService: CommonsDialogService,
              private omsDialogService: OmsDialogService, private moment, private $state, private $window: IWindowService, private threePLService: ThreePLServiceActionsService, private deliveriesRequestsService: DeliveriesRequestsService,
              private actionReasonsDialogsService: ActionReasonsDialogsServiceService, private deliveriesService: DeliveriesService, private IAMPermissions) {
  }

  $onInit() {
    this.siteId = this.splitService.getSiteId();
    this.weightUnit = this.splitService.getWeightUnit();
    this.distanceUnit = this.splitService.getSiteDistanceSmallUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();
    this.settings = this.splitService.getSiteFulfillmentSettings();

    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');

    this.siteLabels = this.splitService.getSiteLabels();
    this.allowPrintingBillOfLading = this.splitService.isPrintingBillOfLadingAllowed();

    this.selectedStep = undefined;
    this.selectedStepNumber = undefined;
    this._setFulfillmentLinesPackages();
    this._setRelations(this.fulfillment.id, _.map(this.fulfillment.fulfillmentSteps, 'id'));

    if (this.doDispatch) {
      this.onDispatch(this.fulfillment);
    }
    if (!this.order && this.fulfillment.orderReference) {
      this.$omsOrder(this.fulfillment.orderReference.id).$instantGet().then(order => this.order = order);
    }
    this._setSelectedKeys();
    this._initSelectedLineIds();
    this.setFulfillmentServiceAreaIds();
    this._setFulfillmentLinesMetadata();

    this.selectedTab = 0;
  }

  $onChanges(changes) {
    if (changes.fulfillment && !changes.fulfillment.isFirstChange()) {
      const currentFulfillment = changes.fulfillment.currentValue;
      const previousFulfillment = changes.fulfillment.previousValue;
      this._setFulfillmentLinesPackages();
      this._setFulfillmentLinesMetadata();
      this.setFulfillmentServiceAreaIds();
      this._addStepNumberToFulfillment(this.fulfillment);
      if (!_.isEqual(_.get(currentFulfillment, 'fulfillmentSteps'), _.get(previousFulfillment, 'fulfillmentSteps'))) {
        this._setRelations(this.fulfillment.id, _.map(this.fulfillment.fulfillmentSteps, 'id'));
      }
      if (currentFulfillment.id !== previousFulfillment.id) {
        this.order = undefined;
        if (this.fulfillment.orderReference) {
          this.$omsOrder(this.fulfillment.orderReference.id).$instantGet().then(order => this.order = order);
        }
      }
      if (!_.isEqual(_.get(currentFulfillment, 'linesInfo'), _.get(previousFulfillment, 'linesInfo'))) {
        this._initSelectedLineIds();
      }
    }

    if ((changes.selectedSteps && !changes.selectedSteps.isFirstChange()) ||
      (changes.selectedStepsIds && !changes.selectedStepsIds.isFirstChange())) {
      this._setSelectedKeys();
    }

    if (changes.excludeMode && !changes.excludeMode.isFirstChange()) {
      this._setSelectedKeys();
    }
  }

  onChangeViewedSteps(stepId) {
    const stepIdIndex = _.findIndex(this.viewedStepsIds, (id: any) => {
      return id === stepId;
    })
    if (stepIdIndex > -1) {
      this.viewedStepsIds = _.filter(this.viewedStepsIds, (stepId, index) => {
        return index !== stepIdIndex;
      })
    } else {
      this.viewedStepsIds = _.concat(this.viewedStepsIds, [stepId]);
    }
  }

  onStepSelect(stepId) {
    this.selectedStep = _.isEqual(_.get(this.selectedStep, 'id'), stepId) ? undefined :
      _.find(this.fulfillment.fulfillmentSteps, (s) => {
        return s.id === stepId;
      });
    this.selectedStepNumber = stepId ? _.findIndex(this.fulfillment.fulfillmentSteps, (s: any) => {
      return s.id === stepId;
    }) + 1 : undefined;
  }

  onSplit(step, stepNumber, event) {
    this.fulfillmentDialogService.splitStep(step, stepNumber, event)
      .then((payload) => {
        this._onSplit(step.id, payload.splitSteps, payload.isDispatch, event);
      })
      .catch((error) => {
        this.$log.debug('Failed to create split step', error);
      })
  }

  onTabSelected(tab) {

    if (tab === 1) {
      if (!this.billingOrder) {
        this.getBillingOrder(this.fulfillment.orderReference.billingOrderId);
      }
    }
  }

  onSetEditPricingMode(isBillingOrderPanelInEditMode) {
    this.isBillingOrderPanelInEditMode = isBillingOrderPanelInEditMode;
  }

  onDispatchStep(fulfillment, step, $event) {
    const stepIds = [step.id];
    this.onDispatch(fulfillment, stepIds, $event);
  }

  onDispatch(fulfillment, stepIds?, event?) {
    const resolvedStepIds = this.doDispatch ?
      _.map(this.fulfillment.fulfillmentSteps, 'id') :
      (stepIds?.length ? stepIds : this._getSelectedLineStepIds());
    if (this.isShowLineCheckboxes && !resolvedStepIds?.length) {
      return;
    }
    this.doDispatch = false;
    this.fulfillmentDialogService.dispatchStep(fulfillment, this._resolveDispatchStepIds(resolvedStepIds), event)
      .then(() => {
        this._refreshFulfillment();
      })
      .catch((error) => {
        this.$log.debug('Failed to dispatch step', error);
      })
  }

  onLineSelectedChange() {
    this._updateIsAllLinesSelected();
    this._notifyLineSelectionChange();
  }

  onSelectAllLinesChanged() {
    _.forEach(this.fulfillment.linesInfo, (line) => {
      this.selectedLineIds[line.id] = this.isAllLinesSelected;
    });
    this._updateIsAllLinesSelected();
    this._notifyLineSelectionChange();
  }

  onDispatchExternal(fulfillment, step, event?) {
    this.fulfillmentDialogService.dispatchStepExternal(fulfillment.id, step, event)
      .then((selectedQuote) => {
        this.fulfillmentService.dispatchStep(fulfillment.id, step.id, selectedQuote)
          .then(() => {
            this._refreshFulfillment();
          });
      })
      .catch((error) => {
        this.$log.debug('Failed to dispatch step', error);
      })
  }

  onCreateInvoice($event) {
    this.bringozLoaderService.on();
    this.$billingAccounts(this.billingOrder.accountReference.billingAccountId).$asyncValue()
      .then((billingAccount) => {
        this._openCreateInvoiceDialog($event, billingAccount);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onOpen($mdMenu, event) {
    $mdMenu.open(event);
  }


  onCancelOrder(orderId, fulfillment, event) {
    this.omsService.onCancelOrder(orderId, event)
      .then(() => {
        this._refreshFulfillment();
      });
  }

  onSetOrderOnHold(orderId, fulfillment) {
    this.omsService.onSetOrderOnHold(orderId)
      .then(() => {
        this._refreshFulfillment();
      })
  }

  onEditOrder(orderId) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('order.edit', {id: orderId, siteId: siteId});
    this.$window.open(url, '_blank');
  }

  onDuplicateOrder(orderId) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('order.duplicate', {id: orderId, siteId: siteId});
    this.$window.open(url, '_blank');
  }

  onAddOrderNote(orderId, fulfillment, event) {
    this.omsService.onAddNote(event, orderId);
  }

  onPrintBillOfLading() {
    this.omsService.onGetBOLOrderIdToPdf(this.fulfillment.orderReference.id)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.filePrinter(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onDownloadBillOfLading() {
    this.omsService.onGetBOLOrderIdToPdf(this.fulfillment.orderReference.id)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.fileDownloader(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onEmailBol() {
    this.commonsDialogService.emailsDialog(event)
      .then((res) => {
        this.omsService.emailBOL(res.emailRecipients, res.note, this.order.id);
      })
  }

  onOrderUpdate(order) {
    this.bringozLoaderService.on();
    if (order.status === 'Completed') {
      this.omsService.updateCompletedOrder(order.id, order)
        .then((updatedOrder) => {
          this.omsOrdersAlertsService.updateSuccess();
          this.order = updatedOrder;
        })
        .catch((error) => {
          this.omsOrdersAlertsService.updateError(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    } else {
      this.omsRequestsService.updateOrder(order.id, order)
        .then((updatedOrder) => {
          this.omsOrdersAlertsService.updateSuccess();
          this.order = updatedOrder;
        })
        .catch((error) => {
          this.omsOrdersAlertsService.updateError(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    }
  }

  onAutoAssign(serviceId, $event) {
    this.DeliveriesApiAction.autoAssignAgent($event, serviceId)
      .then(() => {
        this._refreshFulfillment();
      });
  }

  onAssignAgent(serviceId, $event) {
    this.DeliveriesApiAction.assignAgent($event, serviceId)
      .then(() => {
        this._refreshFulfillment();
      });
  }

  onAssignResourceAllocation(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.assignResourceAllocation($event, serviceId)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(() => {
            this._refreshFulfillment();
          })
      })
  }

  onCancelService(serviceId, serviceType, $event, serviceSubType) {
    if (serviceSubType === 'ThirdParty') {
      this.actionReasonsDialogsService.createThreeplServiceCancelReason([serviceId], $event, 'Cancel Service', true, [serviceType])
        .then((payload) => {
          this._cancelService(serviceId, payload, serviceSubType)
        })
    } else {
      this.actionReasonsDialogsService.createCancelTaskReason([serviceId], $event, true, undefined, [serviceType])
        .then((payload) => {
          this._cancelService(serviceId, payload, serviceSubType, serviceType, $event)
        })
    }
  }

  onCancelAttempt(serviceId, serviceType, stepId, event) {

    this.fulfillmentDialogService.createCancelTaskReason([serviceId], event, undefined, [serviceType])
      .then((payload) => {
        this._cancelFulfillmentStepAttempt(stepId, payload.cancelReason);
      })
      .catch((error) => {
        this.$log.debug('Dialog Closed');
      })
  }

  onResetService(serviceId, serviceType, $event, fulfillment) {
    this.DeliveriesApiAction.reset($event, serviceId, serviceType)
      .then(() => {
        this._refreshFulfillment();
      })
  }

  onCancelLine(fulfillmentLine, $event) {
    const text = 'Are you sure you want to cancel this line?';
    this.confirmDialogService.confirm('Confirm Cancel Line', text, $event)
      .then(() => {
        this._cancelFulfillmentLine(fulfillmentLine.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreateReturnDeliveryOrder(fulfillmentLine) {
    const newOrder = {
      accountId: _.get(this.order, 'accountId'),
      returnFulfillmentLine: {
        id: 1,
        type: "ReturnDelivery",
        price: undefined,
        packageList: [],
        programType: undefined,
        programName: undefined,
        itemIds: [],
        pickupTask: {
          notBefore: undefined,
          notAfter: undefined,
          purpose: undefined,
          schedulingRequired: undefined,
          obligateTimeWindow: undefined
        },
        destinationTask: {
          purpose: "Dropoff",
          notBefore: undefined,
          notAfter: undefined,
          contact: {},
          location: undefined,
          schedulingRequired: undefined,
          obligateTimeWindow: undefined
        }
      },
      itemLines: []
    }
    newOrder.returnFulfillmentLine.pickupTask = angular.copy(fulfillmentLine.destinationTask);
    newOrder.returnFulfillmentLine.pickupTask.purpose = 'Pickup';
    newOrder.returnFulfillmentLine.destinationTask = angular.copy(fulfillmentLine.pickupTask);
    newOrder.returnFulfillmentLine.destinationTask.purpose = 'Dropoff';
    if (newOrder.returnFulfillmentLine.pickupTask.schedulingRequired || newOrder.returnFulfillmentLine.destinationTask.schedulingRequired) {
      newOrder.returnFulfillmentLine.pickupTask.schedulingRequired = true;
      newOrder.returnFulfillmentLine.destinationTask.schedulingRequired = true;
      newOrder.returnFulfillmentLine.pickupTask.notBefore = undefined;
      newOrder.returnFulfillmentLine.pickupTask.notAfter = undefined;
      newOrder.returnFulfillmentLine.destinationTask.notBefore = undefined;
      newOrder.returnFulfillmentLine.destinationTask.notAfter = undefined;
    } else {
      if (newOrder.returnFulfillmentLine.pickupTask.notBefore < this.moment().startOf('day').valueOf()) {
        newOrder.returnFulfillmentLine.pickupTask.notBefore = this.moment().startOf('day').valueOf();
        newOrder.returnFulfillmentLine.pickupTask.notAfter = this.moment().endOf('day').valueOf();
        newOrder.returnFulfillmentLine.destinationTask.notBefore = this.moment().startOf('day').valueOf();
        newOrder.returnFulfillmentLine.destinationTask.notAfter = this.moment().endOf('day').valueOf();
      } else {
        newOrder.returnFulfillmentLine.destinationTask.notBefore = newOrder.returnFulfillmentLine.pickupTask.notBefore;
        newOrder.returnFulfillmentLine.destinationTask.notAfter = newOrder.returnFulfillmentLine.pickupTask.notAfter;
      }
    }
    newOrder.returnFulfillmentLine.programType = angular.copy(fulfillmentLine.programType);
    newOrder.returnFulfillmentLine.programName = angular.copy(fulfillmentLine.programName);

    _.forEach(getFulfillmentLineItems(fulfillmentLine, this.order.itemLines), item => {
      newOrder.returnFulfillmentLine.itemIds.push(item.id);
      newOrder.itemLines.push(item);
    })

    this.omsDialogService.onCreateReturnDeliveryOrder(newOrder, fulfillmentLine)
      .then((order) => {
        this._onCreateReturnDeliveryOrder(this.order.id, fulfillmentLine.id, order);
      })
      .catch(data => {
        if (data?.isAdvanced) {
          data.order.fulfillmentLines = [];
          data.order.fulfillmentLines.push(data.order.returnFulfillmentLine)
          delete data.order.returnFulfillmentLine;
          data.order.blockedByOrders = [];
          const blockedByOrder = {
            omsOrderId: this.order.id,
            fulfillmentLineId: fulfillmentLine.id
          }
          data.order.blockedByOrders.push(blockedByOrder)

          this.$state.go('order-create', {order: data.order});
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onAssignRoute(serviceId, $event) {
    this.DeliveriesApiAction.assignRoute($event, serviceId)
      .then(() => {
        this._refreshFulfillment();
      });
  }

  onCompleteManuallyService(serviceId, $event) {
    this.DeliveriesApiAction.manualHandle($event, serviceId)
      .then(() => {
        this._refreshFulfillment();
      });
  }

  onCompleteManuallyStepAttempt(stepId, $event) {
    this.fulfillmentDialogService.manualHandle($event, stepId)
      .then((note) => {
        this._manualHandleFulfillmentStep(stepId, note);
      })
      .catch((error) => {
        this.$log.debug('Dialog Closed');
      })
  }


  onAddNoteToService(serviceId, $event, serviceSubType) {
    this.commonsDialogService.note($event, [serviceId])
      .then((note) => {
        this._addNoteToService(serviceId, note, serviceSubType);
      })
  }

  onCreateRoute(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.createRoute($event, [serviceId])
      .then(() => {
        this.fulfillmentService.getFulfillment(this.fulfillment.id, true)
          .then(updatedFulfillment => {
            this.onFulfillmentUpdate({updatedFulfillment: updatedFulfillment})
          })
      });
  }

  editStepsPrice() {
    this._getFulfillmentStepsPriceInfo().then(() => {
      this.fulfillmentDialogService.editStepsPrice(this.fulfillment, this.fulfillmentStepsPriceInfo)
        .then(priceInfo => {
          this._editFulfillmentStepsPriceInfo(priceInfo);
        })
        .catch((error) => {
          this.$log.debug('Failed to dispatch step', error);
        })
    });
  }

  onRestoreFulfillment(fulfillment, $event) {
    if (!fulfillment.serviceTemplateId) {
      this.fulfillmentService.restoreFulfillment(fulfillment.id, false);
      return;
    }
    this.fulfillmentDialogService.restoreFulfillments([fulfillment.id], $event)
      .then((copyStepTemplateId) => {
        this.fulfillmentService.restoreFulfillment(fulfillment.id, copyStepTemplateId);
      })
  }

  onDeleteInvoice(billingOrder, $event) {
    this.billingAccountDialogService.deleteInvoice($event, billingOrder)
      .then(() => {
        this._deleteInvoice(billingOrder.id);
      })
  }

  onSplitPackage(packageItem) {
    const fulfillmentStepsOptions = _.filter(this.fulfillment.fulfillmentSteps, s => {
      const prePickupAttemptStatuses = this.fulfillmentService.getPrePickupAttemptStatuses();
      const lastAttempt = _.find(s.attempts, a => a.referenceId === s.referenceId);

      return s.status !== this.fulfillmentStepStatusType.Completed && s.status !== this.fulfillmentStepStatusType.Canceled &&
        (!_.includes(_.map(packageItem.executionSteps, 'id'), s.id)) && (s.groupId === packageItem.executionSteps[0].groupId) &&
        (!lastAttempt || prePickupAttemptStatuses.includes(lastAttempt.status));
    });

    this.fulfillmentDialogService.splitPackages(fulfillmentStepsOptions, packageItem)
      .then(payload => {
        this.fulfillmentService.splitStepPackages(this.fulfillment.id, payload.executionStep.id, payload.data)
          .then(() => {
            this._refreshFulfillment();
          })
      });
  }

  onCancelStep(step) {
    if (step.status === FulfillmentStepStatusType.Pending) {
      this.confirmDialogService.confirm('Confirm Leg Cancellation',
        'Upon canceling a Leg, the associated packages will not form a gap, the Order will remain unchanged, however, this action might impact related Legs or Lines. Are you sure you want to proceed?', event)
        .then(() => {
          this._onCancelStep(this.fulfillment.id, step.id);
        })
    } else {
      const activeAttempt = _.find(step.attempts, (a) => {
        return a.referenceId === step.referenceId;
      });
      this.fulfillmentDialogService.createCancelTaskReason([activeAttempt.id], event, 'Confirm Leg Cancellation', activeAttempt.type)
        .then((payload) => {
          this._onCancelStep(this.fulfillment.id, step.id, payload.cancelReason);
        })
        .catch((error) => {
          this.$log.debug('Dialog Closed');
        })
    }
  }

  onForceCompleteLine(fulfillmentLine) {
    const fulfillmentLineSteps = this.fulfillment.fulfillmentSteps.filter(s => {
      return s.fulfillmentLineId === fulfillmentLine.id
    })
    const hasArrivedDestinationStepStatus = fulfillmentLineSteps.some(s => {
      return s.displayStatus === this.fulfillmentStepDisplayStatus.ArrivedDestination;
    })

    if (hasArrivedDestinationStepStatus) {
      this.commonsDialogService.infoDialog('Action Blocked: Leg Status Conflict', `You are attempting to force complete a Line, but at least one associated Leg is currently in the 'Arrived Destination' status.
       Force completion of the Line is not allowed while any Leg is at this status. Please review and update the status of the Leg(s) before attempting this action again.`);
    } else {
      this.confirmDialogService.confirm('Confirm Line Completion', `You are about to manually complete this Line. This means all remaining inactive or in-progress Legs associated with this Line will be canceled,
       and any remaining packages will not be marked as missing or result in gaps. Confirm this action?`, event)
        .then(() => {
          this._onForceCompleteLine(fulfillmentLine);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed', error);
        })
    }
  }

  private _onCreateReturnDeliveryOrder(currentOrderId, duplicatedFulfillmentLineId, newOrder) {
    this.omsService.createReturnDeliveryOrder(currentOrderId, duplicatedFulfillmentLineId, newOrder)
      .then((order: any) => {
        const url = this.$state.href('order', {id: order.id, siteId: this.siteId});
        this.$window.open(url, '_blank');
      });
  }

  private _cancelService(serviceId, payload, serviceSubType, serviceType?, $event?) {
    if (serviceSubType === 'ThirdParty') {
      this.threePLService.cancelService([serviceId], payload.cancelReason);
    } else {
      const totalIds = _.concat([serviceId], payload.relatedServicesIds);
      this.deliveriesService.cancelService($event, totalIds, serviceType, payload.cancelReason)
    }
  }

  private _addNoteToService(serviceId, note, serviceSubType) {
    if (serviceSubType === 'ThirdParty') {
      this.threePLService.addNote([serviceId], note);
    } else {
      this.deliveriesRequestsService.addNote([serviceId], note);
    }
  }

  private _onForceCompleteLine(fulfillmentLine) {
    this.fulfillmentService.onForceCompleteLine(this.fulfillment.id, fulfillmentLine.id);
  }

  private _onCancelStep(fulfillmentId, stepId, cancelReason?) {
    this.fulfillmentService.cancelStep(fulfillmentId, stepId, cancelReason);
  }

  private _manualHandleFulfillmentStep(stepId: string, note: string) {
    const payload = {
      note: note,
      fulfillmentFilter: {
        stepFilter: {
          ids: [stepId]
        },
      }
    }

    this.fulfillmentStepService.manualHandleAttempt(payload).then(() => {
      this._refreshFulfillment();
    })
  }

  private _cancelFulfillmentStepAttempt(stepId, cancellationReason: CancellationReason) {
    const payload = {
      ...cancellationReason,
      fulfillmentFilter: {
        stepFilter: {
          ids: [stepId]
        },
      }
    }

    this.fulfillmentStepService.cancelAttempt(payload).then(() => {
      this._refreshFulfillment();
    })
  }

  private _openCreateInvoiceDialog($event, billingAccount) {
    this.billingAccountDialogService.createInvoice($event, [this.billingOrder.id], billingAccount)
      .then((invoicePayload) => {
        invoicePayload.billingAccountId = this.billingOrder.accountReference.billingAccountId;
        this._createInvoice(invoicePayload);
      })
  }

  private _createInvoice(invoicePayload) {
    this.billingOrderService.createInvoice(invoicePayload)
      .then(() => {
      })
  }

  private _editFulfillmentStepsPriceInfo(priceInfo) {
    const stepsPriceFactor = _.flatMap(priceInfo.linesInfo, 'steps');
    this.fulfillmentService.editFulfillmentStepsPriceFactor(this.fulfillment.id, stepsPriceFactor).then(() => {
      this._getFulfillmentStepsPriceInfo();
    });
  }

  private _getFulfillmentStepsPriceInfo() {
    const stepIds = _.map(this.fulfillment.fulfillmentSteps, 'id');
    return this.fulfillmentService.getFulfillmentStepsPrice(this.fulfillment.id, stepIds).then((priceInfo: any) => {
      this.fulfillmentStepsPriceInfo = priceInfo;
      _.forEach(priceInfo.linesInfo, line => {
        if (!this.fulfillmentLineStepsPriceInfoMap[line.lineId]) {
          this.fulfillmentLineStepsPriceInfoMap[line.lineId] = {}
        }
        this.fulfillmentLineStepsPriceInfoMap[line.lineId] = line;
      })
    })
  }

  private _setFulfillmentLinesPackages() {
    _.forEach(this.fulfillment.linesInfo, fulfillmentLine => {
      let packages = _.filter(_.get(this.fulfillment, 'packages', []), p => {
        return _.includes(_.get(fulfillmentLine, 'itemIds', []), p.id);
      })
      if (!packages.length) {
        packages = _.get(this.fulfillment, 'packages', [])
      }
      this.fulfillmentLinesPackages[fulfillmentLine.id] = packages;
    })
  }

  private _setFulfillmentLinesMetadata() {
    this.fulfillmentLinesMetadataMap = {};
    _.forEach(this.fulfillment.fulfillmentSteps, step => {
      if (step.fulfillmentLineId && step.metaData?.length) {
        if (!this.fulfillmentLinesMetadataMap[step.fulfillmentLineId]) {
          this.fulfillmentLinesMetadataMap[step.fulfillmentLineId] = [];
        }
        this.fulfillmentLinesMetadataMap[step.fulfillmentLineId] = _.uniqBy(this.fulfillmentLinesMetadataMap[step.fulfillmentLineId].concat(step.metaData), 'key');
      }
    })
  }

  private _deleteInvoice(billingOrderId) {
    this.billingOrderService.deleteInvoice(billingOrderId)
      .then((res) => {
        this.billingOrder = angular.copy(res);
      })
  }


  private _onSplit(stepId, splitSteps, isDispatch, event) {
    this.fulfillmentService.splitStep(this.fulfillment.id, stepId, splitSteps)
      .then((newSteps) => {
        this._refreshFulfillment();
      })
      .catch((error) => {
        this.$log.debug('Failed to split step', error);
      })
  }

  private _setRelations(fulfillmentId, stepIds) {
    if (!!_.get(stepIds, 'length')) {
      this.fulfillmentService.getRelations(fulfillmentId, stepIds)
        .then((relations) => {
          this.relations = relations;

          if (relations?.length) {
            const isTarget = !!_.includes(relations[0].targetIds, _.get(this.fulfillment, 'fulfillmentSteps[0].id'));
            const relationType = relations[0].relationType;

            this.fulfillmentRelationType = relationType === 'Blocking' ?
              (!!isTarget ? 'BlockedBy' : 'Blocking') :
              (!!isTarget ? 'Blocking' : 'Blocking');

            this.fulfillmentRelatedOrderId = !!isTarget ?
              _.get(relations, '[0].sourceReferencesExpanded[0].orderId') :
              _.get(relations, '[0].targetReferencesExpanded[0].orderId');
          }

        })
    }
  }

  private _cancelFulfillmentLine(fulfillmentLineId) {
    this.omsService.cancelFulfillmentLines(this.order.id, [fulfillmentLineId])
      .then(() => {
        this._refreshFulfillment();
      })
  }

  private _refreshFulfillment() {
    // this.fulfillmentService.getFulfillment(this.fulfillment.id, true)
    //   .then(updatedFulfillment => {
    //     const updatedFulfillmentCopy = angular.copy(updatedFulfillment);
    //     this._addStepNumberToFulfillment(updatedFulfillmentCopy);
    //     this.onFulfillmentUpdate({updatedFulfillment: updatedFulfillmentCopy});
    //   })
  }

  private getBillingOrder(billingOrderId) {
    this.billingOrderService.getBillingOrder(billingOrderId)
      .then((billingOrder) => {
        this.billingOrder = billingOrder;
      })
  }

  private _addStepNumberToFulfillment(fulfillment) {
    _.forEach(fulfillment.fulfillmentSteps, (s, index) => {
      s.stepNumber = index + 1
    })
  }

  private _setSelectedKeys() {
    if (!this.selectedStepsIds && !this.selectedSteps) {
      return;
    }
    this.selectedKeys = {};
    const selectedIds = this.selectedStepsIds || this.selectedSteps.map(step => {
      return step.id
    });
    _.forEach(selectedIds, (id) => {
      this.selectedKeys[id] = true;
    });
  }

  private _initSelectedLineIds() {
    if (!this.isShowLineCheckboxes || !this.fulfillment?.linesInfo?.length) {
      return;
    }
    this.selectedLineIds = {};
    _.forEach(this.fulfillment.linesInfo, (line) => {
      this.selectedLineIds[line.id] = true;
    });
    this.isAllLinesSelected = true;
    this.isSomeLinesSelected = false;
    this._notifyLineSelectionChange();
  }

  private _updateIsAllLinesSelected() {
    this.isAllLinesSelected = _.every(this.fulfillment.linesInfo, (line) => {
      return !!this.selectedLineIds[line.id];
    });
    this.isSomeLinesSelected = !this.isAllLinesSelected && _.some(this.fulfillment.linesInfo, (line) => {
      return !!this.selectedLineIds[line.id];
    });
  }

  private _getSelectedLineStepIds(): string[] {
    if (!this.isShowLineCheckboxes || !this.fulfillment?.linesInfo?.length) {
      return [];
    }
    return _.chain(this.fulfillment.linesInfo)
      .filter((line) => {
        return !!this.selectedLineIds[line.id];
      })
      .flatMap((line) => {
        return _.filter(this.fulfillment.fulfillmentSteps, (s) => {
          return s.fulfillmentLineId === line.id && s.status !== 'Splitted' && this._isDispatchableStep(s);
        });
      })
      .map('id')
      .value();
  }

  private _isDispatchableStep(step) {
    return step.status !== this.fulfillmentStepStatusType.Completed &&
      step.status !== this.fulfillmentStepStatusType.Failed &&
      step.status !== this.fulfillmentStepStatusType.OnHold &&
      step.status !== this.fulfillmentStepStatusType.Canceled;
  }

  private _notifyLineSelectionChange() {
    if (this.onLineSelectionChange) {
      this.onLineSelectionChange({stepIds: this._getSelectedLineStepIds()});
    }
  }

  private _resolveDispatchStepIds(stepIds: string[]) {
    if (this.isShowLineCheckboxes) {
      return stepIds || [];
    }
    return stepIds?.length ? stepIds : undefined;
  }

  private setFulfillmentServiceAreaIds() {
    this.fulfillmentServiceAreaIds = [];
    this.fulfillment.linesInfo.forEach(line => {
      if (line.pickupTask?.location?.areaIds?.length) {
        this.fulfillmentServiceAreaIds = this.fulfillmentServiceAreaIds.concat(line.pickupTask.location.areaIds);
      }
      if (line.destinationTask?.location?.areaIds?.length) {
        this.fulfillmentServiceAreaIds = this.fulfillmentServiceAreaIds.concat(line.destinationTask.location.areaIds);
      }
    })
    this.fulfillmentServiceAreaIds = _.uniq(this.fulfillmentServiceAreaIds);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentView', {
    bindings: {
      fulfillment: '<',
      order: '<?',
      fulfillmentLineStatus: '<',
      showOrderData: '<',
      isShowCheckboxes: '<',
      isShowLineCheckboxes: '<?',
      doDispatch: '<?',
      canFullView: '<',
      isFullView: '<?',
      isPanelOpen: '<?',
      selectedSteps: '<?',
      selectedStepsIds: '<?',
      excludeMode: '<?',
      isMobile: '<?',
      onToggleSelect: '&',
      onLineSelectionChange: '&',
      onToggleFullView: '&',
      onToggleBack: '&',
      onFulfillmentUpdate: '&',
      onBack: '&'
    },
    template: require('./fulfillment-view.html').default,
    controller: FulfillmentViewComponent
  });
